import { cn } from '@tebuto/lib/utils'
import type { JSX } from 'react'

interface DescriptionProps {
    description?: string
    className?: string
}

export default function Description({ description, className }: DescriptionProps): JSX.Element {
    if (description) {
        return (
            <p
                className={cn(
                    'mt-1 ml-1 max-w-full text-xs leading-tight break-words text-foreground-muted',
                    className
                )}
            >
                {description}
            </p>
        )
    }
    return <></>
}
